import React from "react";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import type { InfoTooltipProps } from "./types/types";

/** Above modal overlay (`z-[9999]`) — same layer as select menus over modals */
const TOOLTIP_Z_INDEX = 10001;

const StyledInfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
	verticalAlign: "middle",
	transition: "color 0.2s, transform 0.2s",
	cursor: "pointer",
	borderRadius: "50%",
	"&:hover, &:focus": {
		color: "#1976d2",
		background: "#f0f6ff",
		transform: "scale(1.12)",
		outline: "none",
	},
	"&:focus-visible": {
		boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
	},
}));

const InfoTooltip: React.FC<InfoTooltipProps> = ({
	tooltip,
	iconProps,
	className = "",
	slotProps,
	PopperProps,
	...tooltipProps
}) => (
	<Tooltip
		title={tooltip}
		arrow
		placement="right"
		{...tooltipProps}
		PopperProps={{
			...PopperProps,
			sx: [{ zIndex: TOOLTIP_Z_INDEX }, ...(PopperProps?.sx ? (Array.isArray(PopperProps.sx) ? PopperProps.sx : [PopperProps.sx]) : [])],
		}}
		slotProps={{
			...slotProps,
			popper: {
				...(typeof slotProps?.popper === "object" ? slotProps.popper : {}),
				sx: {
					zIndex: TOOLTIP_Z_INDEX,
					...(typeof slotProps?.popper === "object" && slotProps.popper && "sx" in slotProps.popper
						? (slotProps.popper.sx as object)
						: {}),
				},
			},
		}}>
		<span className={`align-middle ${className}`} tabIndex={0} aria-label="More info">
			<StyledInfoIcon {...iconProps} />
		</span>
	</Tooltip>
);

export default InfoTooltip;
